import { useEffect, useState } from 'react';

export const useWeatherWallMaxColumns = () => {
  const [wallMaxColumns, setWallMaxColumns] = useState(4);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1000) setWallMaxColumns(1);
      else if (window.innerWidth < 1400) setWallMaxColumns(2);
      else if (window.innerWidth < 1600) setWallMaxColumns(3);
      else setWallMaxColumns(4);
    };
    handleResize();
    if (window) window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return wallMaxColumns;
};
